import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BllSkeletonTextComponent } from './skeleton-text.component';

@NgModule({
  imports: [CommonModule],
  declarations: [BllSkeletonTextComponent],
  exports: [BllSkeletonTextComponent],
})
export class BllSkeletonTextModule {}
